import React, { FC, useState, useEffect } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { ReduxState } from '../../common/reducers';
import { loadCurrentInvitation } from '../Redux/Actions';
import ExistingAccount from './ExistingAccount';
import CompleteProfile from './CompleteProfile';
import FailedInvitation from './FailedInvitation';
import { CheckDelegationInvitationValidityQueryResponse } from '../../Services/ClientProxy/clientProxy';

const emptyInvitation = new CheckDelegationInvitationValidityQueryResponse();
const mapStateToProps = (state: ReduxState) => ({
    invitation: state.invitation.currentInvitation ?? emptyInvitation,
    lastError: state.invitation.lastError,
});

const mapDispatchToProps = {
    dispatchLoadCurrentInvitation: loadCurrentInvitation,
};

export interface Props {
    id: string;
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const ValidateInvitation: FC<PropsFromRedux & Props> = (
    props: PropsFromRedux & Props
) => {
    const { invitation, dispatchLoadCurrentInvitation, id,lastError } = props;
    const [currentInvitation, setCurrentInvitation] = useState(invitation);
    const [Error, setError] = useState<string>();

    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (invitation === emptyInvitation) {
            setIsLoading(true);
            dispatchLoadCurrentInvitation(id);
        } else {
            setIsLoading(false);
        }
        setCurrentInvitation(invitation);
    }, [id, invitation, dispatchLoadCurrentInvitation]);


    useEffect(() => {
        
        if (lastError) {
            setError(lastError.serviceError?.toString());
        }
        

    }, [lastError]);

    return (
        <div>
            {!isLoading && !currentInvitation.isValid && (
                <FailedInvitation message={Error} />
            )}
            {!isLoading &&
                currentInvitation.isValid &&
                currentInvitation.hasAccount && (
                    <ExistingAccount
                        invitationData={currentInvitation}
                        invitationId={id}
                    />
                )}
            {!isLoading &&
                currentInvitation.isValid &&
                !currentInvitation.hasAccount && (
                    <CompleteProfile
                        invitationData={currentInvitation}
                        invitationId={id}
                    />
                )}
        </div>
    );
};

export default connector(ValidateInvitation);
